import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgIvermectinGlyph from './svgs/IvermectinGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var ivermectinGlyph = (props => useIcon(SvgIvermectinGlyph, SvgIvermectinGlyph, props));

export { ivermectinGlyph as default };
